module.exports = __webpack_public_path__ + "japan.svg?1f905d23af144bc76e488f00d516de2e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/japan.svg
// module id = 200
// module chunks = 10